/* eslint camelcase: 0 */
import { TalkReader } from '@/infrastructure/network/Monitaro/schema/models'
import { ITalkReaderProps, EmptyTalkReaderPropsFactory } from '@/entities/TalkReader'

export const toTalkReaderProps = (props: TalkReader[] | null | undefined): ITalkReaderProps[] => {
  if (!props) {
    return []
  }

  return props.map((item) => {
    const { id, fullname, organization, icon, read_at } = item

    return EmptyTalkReaderPropsFactory({
      id,
      fullname,
      organization,
      icon,
      readAt: read_at
    })
  })
}
